// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__robotoMedium_a97cab', '__robotoMedium_Fallback_a97cab'","fontWeight":500},"className":"__className_a97cab","variable":"__variable_a97cab"};